const sidebar = false;

const entity = {
  title: "Posts",
  actions: {
    sort: {
      endPoint: "posts/by",
      query: {
        $order: {},
      }
    },
    get: {
      endPoint: "posts/by",
      query: {}
    },
    create: {
      endPoint: "posts"
    },
    filter: {
      endPoint: "posts/by",
      query: {
        $group: "id",
        $where: {}
      }
    }
  }
};

const keys = [{
  dataTableID: "id",
  label: "Id",
  tooltip: "ID to generate this report",
  columnType: "string",
  table: {
    displayOrder: 1
  },
  filter: {
    displayOrder: 1,
    columnType: "select",
    matchType: "", // Values can be gte, lte, gt, lt, By default it is eq
    options: {
      select: [{
        field: "id"
      }],
      title: ["id"],
      value: "id",
      endPoint: "posts/by",
      separator: " ",
      initializer: ""
    }
  }
},
{
  dataTableID: "title",
  label: "Title",
  tooltip: "Title of the post",
  columnType: "string",
  create: {
    displayOrder: 1
  },
  table: {
    displayOrder: 2
  },
  filter: {
    displayOrder: 2
  }
}
];

const tabs = [{
  view: "detailView",
  entity: "posts",
  endPoint: "posts/by",
  title: "Details",
  queryFilter: {
    id: ":id"
  }
}];

export {
  sidebar,
  entity,
  keys,
  tabs
};